import { EnvironmentProviders, Provider } from '@angular/core';
import { storeProviders } from './store/store.config';
import { coreProviders } from './core/core.config';
import { LoginService } from '../login/login.service';
import { TravomateLogoutService } from './login/travomate.logout.service';
import TravomateLoginComponent from './login/travomate.login.component';
import { Routes } from '@angular/router';
import { entitiesProviders } from './entities/entities.config';

export const travomateRoutes: Routes = [
  {
    path: 'login',
    component: TravomateLoginComponent,
    title: 'login.title',
  },
  {
    path: 'full-index',
    data: { pageTitle: 'coreApiApp.fullIndex.home.title' },
    loadChildren: () => import('./entities/full-index/travomate-full-index.routes'),
  },
  {
    path: 'uid-value',
    data: { pageTitle: 'coreApiApp.uidValue.home.title' },
    loadChildren: () => import('./entities/uid-value/travomate-uid-value.routes'),
  },
  {
    path: 'email',
    data: { pageTitle: 'coreApiApp.email.home.title' },
    loadChildren: () => import('./entities/email/travomate.email.routes'),
  },
  {
    path: 'parcel',
    data: { pageTitle: 'coreApiApp.parcel.home.title' },
    loadChildren: () => import('./entities/parcel/travomate-parcel.routes'),
  },
];

export const travomateProviders: Array<Provider | EnvironmentProviders> = [
  ...coreProviders,
  ...storeProviders,
  ...entitiesProviders,
  { provide: LoginService, useClass: TravomateLogoutService },
];
